"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.msgEditNFT = void 0;
var ow_1 = __importDefault(require("ow"));
var ow_types_1 = require("../ow.types");
var address_1 = require("../../../utils/address");
var typeurl_1 = require("../../common/constants/typeurl");
exports.msgEditNFT = function (config) {
    return (function () {
        function MsgEditNFT(options) {
            ow_1.default(options, 'options', ow_types_1.owMsgEditNFTOptions);
            this.id = options.id;
            this.name = options.name;
            this.sender = options.sender;
            this.denomId = options.denomId;
            this.uri = options.uri;
            this.data = options.data;
            this.validateAddresses();
        }
        MsgEditNFT.prototype.toRawMsg = function () {
            return {
                typeUrl: typeurl_1.COSMOS_MSG_TYPEURL.nft.MsgEditNFT,
                value: {
                    id: this.id,
                    name: this.name,
                    sender: this.sender,
                    denomId: this.denomId,
                    uri: this.uri,
                    data: this.data,
                },
            };
        };
        MsgEditNFT.prototype.toRawAminoMsg = function () {
            return {
                type: 'chainmain/nft/MsgEditNFT',
                value: {
                    id: this.id,
                    name: this.name,
                    sender: this.sender,
                    denom_id: this.denomId,
                    uri: this.uri,
                    data: this.data,
                },
            };
        };
        MsgEditNFT.prototype.validateAddresses = function () {
            if (!address_1.validateAddress({
                address: this.sender,
                network: config.network,
                type: address_1.AddressType.USER,
            })) {
                throw new TypeError('Provided `sender` does not match network selected');
            }
        };
        return MsgEditNFT;
    }());
};
//# sourceMappingURL=MsgEditNFT.js.map